module.exports = __webpack_public_path__ + "img/jackal.d2400fc5.jpg";